<template>
  <div class="page_diaobo">
    <Add
      v-if="showAdd"
      :showType="showType"
      :showData="showData"
      @close="addClose"
    ></Add>
    <div class="list_page" v-else>
      <van-nav-bar
        title="调拨出库记录"
        left-text="返回"
        right-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="1"
      />
      <div class="list_box">
        <SList url="/emm/independent/getListByPage">
          <template slot-scope="{ row }">
            <van-cell
              value="查看详情"
              :title="row.classificationName"
              is-link
              @click="showAddClick(3, row)"
            >
            </van-cell>
            <div class="other" @click="showAddClick(3, row)">
              <p>
                需求地：<span>{{ row.eventOrigin }}</span>
              </p>
              <p>
                库点名称：<span>{{ row.warehouseName }}</span>
              </p>
              <p>
                调拨单位：<span>{{ row.organName }}</span>
              </p>
              <p>
                调拨函编号：<span>{{ row.independentCode }}</span>
              </p>
              <p>
                创建时间：<span>{{ row.createTime }}</span>
              </p>
            </div>
          </template>
        </SList>
      </div>
    </div>
  </div>
</template>
<script>
import Add from "./add.vue";
export default {
  components: { Add },
  data() {
    return {
      routerInType: this.$route.query.type,
      showAdd: false,
      showType: 1, //0直接新增,1列表新增,2编辑,3查看
      showData: {},
    };
  },
  created() {
    if (this.routerInType === "add") {
      this.showAddClick(1);
    }
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    showAddClick(type, row) {
      this.showType = type;
      if (type > 1 && row) {
        this.showData = row;
      }
      this.showAdd = true;
    },
    addClose() {
      if (this.routerInType === "add") {
        this.$router.go(-1);
      } else {
        this.showAdd = false;
      }
    },
  },
};
</script>
<style lang="scss">
.page_diaobo {
  .list_page {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .van-nav-bar {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .list_box {
      width: 100%;
      height: calc(100% - 44px);
      .other {
        background-color: #fff;
        padding: 5px 10px 16px 10px;
        margin-bottom: 10px;
        font-size: 14px;
        p {
          color: rgb(153, 154, 160);
          margin: 5px 0;
          span {
            color: rgb(90, 91, 94);
          }
        }
      }
    }
  }
}
</style>